module.exports = __webpack_public_path__ + "img/erik.7f37e49a.png";